(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("YXTPC"), require("Vue"), require("Vuex"), require("axios"), require("VueI18n"));
	else if(typeof define === 'function' && define.amd)
		define(["YXTPC", "Vue", "Vuex", "axios", "VueI18n"], factory);
	else if(typeof exports === 'object')
		exports["YXTBIZ"] = factory(require("YXTPC"), require("Vue"), require("Vuex"), require("axios"), require("VueI18n"));
	else
		root["YXTBIZ"] = factory(root["YXTPC"], root["Vue"], root["Vuex"], root["axios"], root["VueI18n"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__10__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__23__, __WEBPACK_EXTERNAL_MODULE__85__) {
return 